import { render, staticRenderFns } from "./ViewClientCustomPolygon.vue?vue&type=template&id=1ad47cb6"
import script from "./ViewClientCustomPolygon.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewClientCustomPolygon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ViewClientCustomPolygon.vue?vue&type=style&index=0&id=1ad47cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports